import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import "../components/Styles/home3.css";
import MEN from "../images/MEN.png";
import WOMEN from "../images/WOMEN.png";
import LOG from "./log.png";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";

const Home3 = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  const navigate = useNavigate();

  const handleSelect = (gender) => {
    localStorage.setItem("fitness_gender", gender);

    if (gender === "male") {
      navigate("/Male", { replace: true });
    } else {
      navigate("/Female", { replace: true });
    }
  };

  const changeSection = () => {
    localStorage.removeItem("fitness_gender");
    navigate("/Home3", { replace: true });
  };

  return (
    <div>
      <Helmet>
        <title>Choose Training Path</title>
        <meta
          name="description"
          content="Select your program to get started with the right training experience."
        />
      </Helmet>

      <section className="header_tophm3">
        <div className="h_t">
          <img src={LOG} alt="Logo" />

          <h1>
            CHOOSE YOUR{" "}
            <span style={{ color: "#FF006A" }}>TRAINING PATH</span>
          </h1>

          <p>
            Select your program to get started with the right training experience.
          </p>

         <div className="row_hm">

  {/* 🔥 MALE */}
  <div className="col_m">
    <div 
      className="image-wrapper"
      onClick={() => handleSelect("male")}
    >
      <img src={MEN} alt="Male" />
      <div className="image-text">
        <h5>MEN</h5>
        <p>Strength & Kickboxing</p>

      </div>
    </div>
  </div>

  {/* 🔥 FEMALE */}
  <div className="col_m2">
    <div 
      className="image-wrapper"
      onClick={() => handleSelect("female")}
    >
      <img src={WOMEN} alt="Female" />
      <div className="image-text">
  <h5>WOMEN</h5>
        <p>Fitness & Self Defense</p>
        
      </div>
    </div>
  </div>

</div>

          {/* 👇 Now it's a paragraph instead of button */}
         <p
  onClick={changeSection}
  style={{
    marginTop: "10px",
    paddingBottom:"10px",
    cursor: "pointer",
     color: "#8C8C8C",
    textDecoration: "none",
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "1.2px",
    verticalAlign: "middle"
  }}
>
  You can change this later anytime.
</p>
        </div>
      </section>
    </div>
  );
};

export default Home3;
